import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbTabset, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { JhiLanguageService } from 'ng-jhipster';

import { Principal, LoginModalService } from '../../shared';
import { StateStorageService } from '../../shared/auth/state-storage.service';

import { Event } from './event.model';
import { EventService } from './event.service';

@Component({
    selector: 'jhi-event-no-auth',
    templateUrl: './event-detail-no-auth.component.html'
})
export class EventDetailNoAuthComponent implements OnInit, OnDestroy {

    // variables for the tabs
    @ViewChild('tabs')
    tabSet: NgbTabset;
    currentTab: string;

    eventId: number;
    event: Event;
    tempImageUrl: string;
    private eventSubscription: any;

    modalRef: NgbModalRef;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private principal: Principal,
        private loginModalService: LoginModalService,
        private eventService: EventService,
        private stateStorageService: StateStorageService,
        private router: Router,
        private route: ActivatedRoute
    ) {
        this.jhiLanguageService.setLocations(['event', 'eventStatus',
                                              'eventCategory', 'eventReservation',
                                              'eventReservationStatus',
                                              'payment', 'paymentItem', 'paymentType']);
    }

    ngOnInit() {
        this.eventSubscription = this.route.params.subscribe(params => {
            this.eventId = params['id'];
            this.eventService.findNoAuth(this.eventId).subscribe(event => {
                this.event = event;
            });
        });
    }

    onRegisterClicked() {
        if (this.principal.isAuthenticated()) {
            this.router.navigate(['/event', this.event.id]);

            return;
        }

        this.stateStorageService.setPostLoginRedirectUrl( `/event/${this.event.id}`);
        this.modalRef = this.loginModalService.open();
    }

    disableBookButton(): boolean {
        if (!this.event) {
            return true;
        }

        const finalizedStatus: any = 'FINALIZED';
        const cancelledStatus: any = 'CANCELLED';
        const draftStatus: any = 'DRAFT';

        if (this.event.status === finalizedStatus) {
            return true;
        }

        if (this.event.status === cancelledStatus) {
            return true;
        }

        if (this.event.status === draftStatus) {
            return true;
        }

        if (!this.event.acceptOnlinePayments) {
            return true;
        }

        if (!this.event.free) {
            if (!this.event.backOfficeUnitPriceId) {
                return true;
            }

            if (this.event.standardUnitPrice <= 0) {
                return true;
            }

        }

        return false;
    }

    disableBookAndPayLaterButton(): boolean {
        if (!this.event) {
            return true;
        }

        const finalizedStatus: any = 'FINALIZED';
        const cancelledStatus: any = 'CANCELLED';
        const draftStatus: any = 'DRAFT';

        if (this.event.status === finalizedStatus) {
            return true;
        }

        if (this.event.status === cancelledStatus) {
            return true;
        }

        if (this.event.status === draftStatus) {
            return true;
        }

        if (!this.event.free) {
            if (this.event.standardUnitPrice <= 0) {
                return true;
            }
        }

        return false;
    }

    previousState() {
        window.history.back();
    }

    ngOnDestroy() {
        this.eventSubscription.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/event/event-detail-no-auth.component.ts